import { render, staticRenderFns } from "./BackgroundImage.vue?vue&type=template&id=05ed4744&scoped=true&"
import script from "./BackgroundImage.vue?vue&type=script&lang=js&"
export * from "./BackgroundImage.vue?vue&type=script&lang=js&"
import style0 from "../ThemeSettingsChildren.css?vue&type=style&index=0&id=05ed4744&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ed4744",
  null
  
)

export default component.exports